import React from "react";
import Image from "react-bootstrap/Image";
import { Button, Form } from "react-bootstrap";
import CustomForm from "../../../components/customcomponents/CustomForm";
import { Link } from "react-router-dom";
import { IMAGES } from "../../../assets/images/images";

const UserForgotPassword = () => {
  return (
    <section className="login_box">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-md-6 hideloginimg">
            <div className="login_bg">
              <Image src={IMAGES.Login_Bg} className="img-fluid" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="loginBody">
              <Form>
                <h1>Forgot Password</h1>
                <p className="para">
                  Please enter the registered email address to get the
                  verification code to reset your password
                </p>

                <CustomForm
                  className={"mb-3"}
                  color={"#222528"}
                  controlText="email"
                  type="text"
                  lableText="Email"
                  placeholderText="Enter your mail"
                />

                <Button
                  as={Link}
                  to="/user-otp"
                  className="btn btn-primary my-3 mb-4 my-mb-3 mb-md-3 my-lg-3 w-100"
                >
                  Continue
                </Button>

                <p className="text-center">
                  Back To{" "}
                  <Link
                    to="/login"
                    className="forgotPassword forgotPassword1"
                  >
                    Login
                  </Link>
                </p>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UserForgotPassword;
